import { Admin, Resource, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { CategoryList, CategoryEdit, CategoryCreate } from './resources/categories';
import { ProductList, ProductEdit, ProductCreate } from './resources/products';
import { PromoCodeList, PromoCodeEdit, PromoCodeCreate } from './resources/promo-codes';
import { OrderList, OrderShow } from './resources/orders';
import { DeliveryZoneList, DeliveryZoneEdit, DeliveryZoneCreate } from './resources/delivery-zones';
import { SettingsPage } from './resources/settings';
import CategoryIcon from '@mui/icons-material/Category';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MapIcon from '@mui/icons-material/Map';
import SettingsIcon from '@mui/icons-material/Settings';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import russianMessages from 'ra-language-russian';

// Русская локализация
const i18nProvider = polyglotI18nProvider(() => russianMessages, 'ru');

const App = () => (
  <Admin
    authProvider={authProvider}
    dataProvider={dataProvider}
    i18nProvider={i18nProvider}
    title="Food Delivery Admin"
  >
    <Resource
      name="categories/admin"
      list={CategoryList}
      edit={CategoryEdit}
      create={CategoryCreate}
      icon={CategoryIcon}
      options={{ label: 'Категории' }}
    />
    <Resource
      name="products/admin"
      list={ProductList}
      edit={ProductEdit}
      create={ProductCreate}
      icon={RestaurantIcon}
      options={{ label: 'Продукты' }}
    />
    <Resource
      name="promo-codes"
      list={PromoCodeList}
      edit={PromoCodeEdit}
      create={PromoCodeCreate}
      icon={LocalOfferIcon}
      options={{ label: 'Промокоды' }}
    />
    <Resource
      name="delivery-zones"
      list={DeliveryZoneList}
      edit={DeliveryZoneEdit}
      create={DeliveryZoneCreate}
      icon={MapIcon}
      options={{ label: 'Зоны доставки' }}
    />
    <Resource
      name="settings"
      list={SettingsPage}
      icon={SettingsIcon}
      options={{ label: 'Настройки' }}
    />
  </Admin>
);

export default App;
